import { USER_LIST_WITH_TYPE } from '../constants'
const INITIAL_STATE = { userListWithType: { fisherman: null, restaurant: null } }

export default ( state = INITIAL_STATE, action ) => {
  switch( action.type ) {
    case USER_LIST_WITH_TYPE:
      return { ...state, userListWithType: { ...state.userListWithType, ...action.payload} }
    default: 
      return state
  }
}


// WEBPACK FOOTER //
// ./src/reducers/userReducer.js